<template>
  <div>

    <!-- Linha 2: Filtros (Integrados) -->
    <b-card class="mb-3 shadow-sm">
      <b-row class="align-items-end">
        <!-- Filtro Status -->
        <b-col md="3" sm="6">
          <b-form-group label="Status:" label-for="status-filter">
            <v-select
              id="status-filter"
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ value: null, label: 'Todos' }, { value: 'Pendente', label: 'Pendentes' }, { value: 'Aprovado', label: 'Aprovados' }, { value: 'Rejeitado', label: 'Rejeitados' }]"
              :reduce="option => option.value"
              :clearable="false"
              placeholder="Selecione"
              @input="refetchData"
            />
          </b-form-group>
        </b-col>

        <b-col md="3" sm="6">
          <b-form-group label="Método:" label-for="status-filter">
             <v-select
              id="status-filter"
              v-model="metodoFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="[{ value: null, label: 'Todos' }, { value: 'Pix', label: 'Pix' }, { value: 'Transferencia', label: 'Transferência' }]"
              :reduce="option => option.value"
              :clearable="false"
              placeholder="Selecione"
              @input="refetchData"
            />
          </b-form-group>
        </b-col>

        <!-- Filtro Busca -->
        <b-col md="4" sm="8">
          <b-form-group label="Buscar:" label-for="search-filter">
            <b-form-input
              id="search-filter"
              v-model="searchQuery"
              placeholder="Buscar por nome ou ID..."
              @input="refetchData"
            />
          </b-form-group>
        </b-col>

        <!-- Botão Buscar (Ação já ocorre no @input dos filtros) -->
        <b-col md="2" sm="4" class="text-right">
          <b-button variant="warning" @click="refetchData">
            Buscar
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!-- Tabela de Solicitações -->
    <b-card no-body class="shadow-sm">
       <b-card-header>
        <b-card-title>Solicitações de Resgate</b-card-title>
         <!-- Controles de Per Page (opcional, movido para cá se necessário) -->
         <div class="d-flex align-items-center">
            <label class="mr-1 mb-0 small">Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block"
              style="width: 90px;"
            />
            <label class="ml-1 mb-0 small">entradas</label>
          </div>
      </b-card-header>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="findAll"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhuma solicitação encontrada."
        :sort-desc.sync="isSortDirDesc"
        striped
        hover
      >
        <!-- Coluna ID -->
        <template #cell(id)="data">
          <span class="font-weight-bold text-uppercase">#RE{{ data.item.id }}</span> <!-- Adaptado -->
        </template>

        <!-- Coluna Solicitante -->
        <template #cell(usuario)="data">
          <span>
            {{ data.item.usuario.nome_responsavel }} {{ data.item.usuario.sobrenome }}  <!-- Usando preço do item como placeholder -->
          </span>
        </template>

        <!-- Coluna Valor -->
        <template #cell(valor)="data">
          <span>
            {{ data.item.valor | currency }} <!-- Usando preço do item como placeholder -->
          </span>
        </template>

        <!-- Coluna Método -->
        <template #cell(metodo_recebimento)="data">
          {{ data.item.metodo_recebimento }}{{ data.item.tipo_pix ? ` (${data.item.tipo_pix})` : '' }}
        </template>

        <!-- Coluna Data -->
        <template #cell(data_inclusao)="data">
          {{ data.item.data_inclusao | formatDateTimeBr }}
        </template>

        <!-- Coluna Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="getStatusVariant(data.item.status)"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Coluna Ações -->
        <template #cell(actions)="data">
          <b-button variant="warning" size="sm" @click="viewDetails(data.item)"> <!-- Passa o item inteiro -->
            Detalhes
          </b-button>
          <!-- Botão Deletar removido -->
        </template>

      </b-table>

      <!-- Paginação e Contagem -->
      <b-card-footer class="d-flex justify-content-between align-items-center">
        <span class="text-muted small">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} resultados</span>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalClientes"
          :per-page="perPage"
          size="sm"
          align="right"
          class="my-0"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>

    <!-- Modal Detalhes Solicitação (Adicionado anteriormente) -->
    <detalhes-solicitacao-modal
      :visible.sync="showDetalhesModal"
      :solicitacao-detalhes="selectedSolicitacao"
      @action="handleModalAction"
    />

    <!-- Modal Confirm Delete (Removido ou comentado se não for mais usado) -->
    <!-- <ModalConfirm ... /> -->

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BBadge, BPagination, VBModal, VBTooltip, BCardHeader, BCardTitle, BCardFooter,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Vue from 'vue'
import Clipboard from 'v-clipboard'
import axios from '@axios'
import store from '@/store'
import {
  ref, onMounted, getCurrentInstance, computed,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import usePagamentosList from './usePagamentosList'
import router from '@/router'
import { currency, formatDateTimeBr, avatarText } from '@core/utils/filter'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue' // Adicionado FeatherIcon
import DetalhesSolicitacaoModal from '../components/DetalhesSolicitacaoModal.vue' // Adicionado Modal Detalhes

Vue.use(Clipboard)

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    vSelect,
    BCardHeader, // Adicionado
    BCardTitle, // Adicionado
    BCardFooter, // Adicionado
    BFormGroup, // Adicionado
    FeatherIcon, // Adicionado
    DetalhesSolicitacaoModal, // Adicionado
  },
  methods: {
    getStatusVariant(status) {
      if (status === 'Pendente') return 'warning'
      if (status === 'Aprovado') return 'success'
      if (status === 'Rejeitado') return 'danger'
      return 'secondary'
    },
    calculateComissaoValue(preco, percentual) {
      return (preco * (percentual / 100))
    },
    onCopySuccess(e) {
      this.$bvToast.toast('URL copiada com sucesso!', {
        title: 'Sucesso',
        variant: 'success',
        solid: true,
      })
    },
    onCopyError(e) {
      this.$bvToast.toast('Erro ao copiar URL.', {
        title: 'Erro',
        variant: 'danger',
        solid: true,
      })
    },
    async deleteLinkAfiliado(id) {
      try {
        await axios.delete(`/linkafiliado/${id}`)
        this.$bvToast.toast('Afiliação deletada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        })
        // Recarregar a lista de afiliados ou atualizar a tabela
        this.refetchData()
      } catch (error) {
        this.$bvToast.toast('Erro ao deletar afiliação.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  filters: {
    currency,
    formatDateTimeBr,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const toast = useToast()

    const showDetalhesModal = ref(false)
    const selectedSolicitacao = ref(null)

    const viewDetails = (item) => {
      const getUserType = (groupId) => {
        switch (groupId) {
          case 1: return 'ADMIN'
          case 4: return 'Afiliado'
          case 5: return 'Vendedor'
          case 6: return 'Padrinho'
          default: return 'Desconhecido' // Ou outro valor padrão
        }
      }

      // Mapeia o item da tabela para o formato esperado pelo modal (pode precisar de ajustes)
      selectedSolicitacao.value = {
        id: `RE${item.id}`,
        solicitante: {
          nome: item.usuario.nome_responsavel || 'Desconhecido',
          tipo: getUserType(item.usuario.id_grupousuario),
          id: item.usuario.id,
          avatar: item.usuario.foto_perfil || null,
          email: item.usuario.login,
          telefone: item.usuario.celular || null,
          cpf: item.usuario.cpf || null,
        },
        valor: currency(item.valor) || 0,
        descricao: item.descricao || 'Sem descrição',
        observacao: item.observacao || null,
        metodo: {
          tipo: item.metodo_recebimento,
          detalhe: item.tipo_pix || null,
          chave: item.chave_pix || null,
        },
        data: formatDateTimeBr(item.data_inclusao).split(' ')[0], // Usa data formatada
        status: item.status,
      }
      showDetalhesModal.value = true
    }

    const handleModalAction = async (payload) => {
      // console.log('Ação recebida do modal:', payload)
      const statusApi = payload.action === 'aprovar' ? 'Aprovado' : 'Rejeitado'
      // Extrai apenas o ID numérico
      const saqueId = payload.id.replace('RE', '')

      try {
        await axios.put(`/saque/${saqueId}`, {
          status: statusApi,
          observacao: payload.observacoes, // Envia as observações do modal
        })

        if (payload.action === 'aprovar') {
          // Buscar detalhes do saque se necessário (se o valor não estiver disponível no payload)
          let valorSaque = Number(payload.valor.replace(/[R$\s.]/g, '').replace(',', '.'))
          let idUsuario = payload.solicitante
          if (!valorSaque || !idUsuario) {
            // Se o valor ou ID do usuário não estiverem no payload, busca os detalhes do saque
            const respostaSaque = await axios.get(`/saque/${saqueId}`)
            valorSaque = respostaSaque.data.valor
            idUsuario = respostaSaque.data.id_usuario
          }
          // Atualiza o saldo do usuário: remove do saldo_processamento e adiciona ao saldo_resgatado
          const saldoResponse = await axios.get(`/saldo/usuario/${idUsuario}`)
          // 4. Extrai os valores atuais
          const saldoProcessamentoAtual = saldoResponse.data.saldo_processamento || 0
          const saldoResgatadoAtual = saldoResponse.data.saldo_resgatado || 0
          // 5. Calcula novos saldos
          const novoSaldoProcessamento = saldoProcessamentoAtual - valorSaque
          const novoSaldoResgatado = Number(saldoResgatadoAtual) + valorSaque
          // 6. Atualiza o saldo do usuário
          await axios.put(`/saldo/${idUsuario}`, {
            saldo_processamento: novoSaldoProcessamento,
            saldo_resgatado: novoSaldoResgatado,
          })
        }

        toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: `Solicitação ${payload.action === 'aprovar' ? 'aprovada' : 'rejeitada'} com sucesso!`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        refetchData() // Atualiza a tabela
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: `Não foi possível ${payload.action === 'aprovar' ? 'aprovar' : 'rejeitar'} a solicitação.`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const idProduto = ref(null)
    const blankCategoryData = ref({
      id: null,
      item_nome: '',
      item_descricao: '',
      id_categoria: '',
      ativo: 1,
      imagens: [],
    })

    const {
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      categoriaOptions,
      metodoFilter,
    } = usePagamentosList()

    const gruposOptions = ref([])

    const updatedFilter = e => {
      if (e.status) {
        statusFilter.value = e.status
      }
      if (e.metodo_recebimento) {
        metodoFilter.value = e.metodo_recebimento
      }
      refetchData()
    }

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addCliente = async () => {
      blankCategoryData.value = {
        id: null,
        item_nome: '',
        item_descricao: '',
        id_categoria: '',
        ativo: 1,
        imagens: [],
      }
      isAddNewUserSidebarActive.value = true
    }

    const editCliente = id => {
      router.push({ name: 'app-adm-produto-add', params: { id } })
    }

    const viewProduto = id => {
      router.push({ name: 'app-adm-produto-view', params: { id } })
    }

    const deleteCategory = async () => {
      await store.dispatch('appAdmProdutos/delete', { id: idProduto.value })
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Sucesso',
              text: resp.data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idProduto.value = null
          refetchData()
        })
      refetchData()
    }

    onMounted(() => {
      store.dispatch('appAdmSaques/findAll')
    })
    return {
      idProduto,
      addCliente,
      blankCategoryData,
      editCliente,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      findAll,
      tableColumns,
      perPage,
      currentPage,
      totalClientes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      tipoPessoaFilter,
      updatedFilter,
      deleteCategory,
      viewProduto,
      categoriaOptions,
      metodoFilter,

      showDetalhesModal,
      selectedSolicitacao,
      viewDetails,
      handleModalAction,

      // Certifique-se que formatDateTimeBr também está aqui se você o chamou diretamente no template
      formatDateTimeBr,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}

.modal-texto {
  font-size: 1.1rem; /* Aumenta o tamanho da fonte */
  line-height: 1.5; /* Melhora o espaçamento entre linhas */
  font-family: inherit; /* Usa a fonte padrão do sistema ao invés da fonte monospace do pre */
  white-space: pre-wrap; /* Permite quebra de linha automática */
  padding: 1rem; /* Adiciona um espaçamento interno */
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
